// extracted by mini-css-extract-plugin
export default {"helloworld":"Home_helloworld__0N8wP","overlay":"Home_overlay__pJIQZ","popup":"Home_popup__rShF9","topSeparator":"Home_topSeparator__fg7b7","bookNowA":"Home_bookNowA__gQRfI"};